<template>
  <div v-if="LocalDatabase.db">
    <Sidebar v-if="sidebar.show" @close-sidebar="sidebar.show = !sidebar.show"/>
    <div class="header">
     <FontAwesomeIcon class="hamburger" :icon="faBars" @click="sidebar.show = !sidebar.show"/>
      <img class="logo" src="./assets/wordbook-text.png" alt="logo"/>
    </div>
    <router-view class="view-display"/>
    <nav class="bottom-navigation">
      <router-link class="nav-item" to="/">Words</router-link>
      <router-link class="nav-item" to="/games/anki">Anki</router-link>
    </nav>

    <Modal v-if="showLanguageOnboarding">
      <template #header>
        <h2>Which language are you learning?</h2>
      </template>
      <template #content>
        <div class="language-onboarding__flags">
          <img
            v-for="code in translationLanguages"
            :key="code"
            :src="imageURL(flags[code])"
            :alt="languages[code]"
            class="language-onboarding__flag"
            @click="selectTranslationLanguage(code)"
            @keydown="selectTranslationLanguage(code)"
          />
        </div>
      </template>
      <template #footer><span/></template>
    </Modal>
  </div>
  <Spinner v-else />
</template>

<script lang="ts">
import { mixins, Options } from 'vue-class-component';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import Sidebar from '@/components/Sidebar.vue';
import LocalDatabase from '@/includes/db';
import Spinner from '@/components/Spinner.vue';
import Modal from '@/components/Modal.vue';
import ImageMixin from '@/includes/mixin/images.mixin';
import languages, { flags, translationLanguages } from '@/includes/db/data/languages';
import store from '@/includes/store';

@Options({
  components: {
    Spinner,
    FontAwesomeIcon,
    Sidebar,
    Modal,
  },
})
export default class App extends mixins(ImageMixin) {
  faBars = faBars
  LocalDatabase = LocalDatabase;
  languages = languages;
  flags = flags;
  translationLanguages = translationLanguages;
  sidebar = {
    show: false,
  };

  // eslint-disable-next-line class-methods-use-this
  get showLanguageOnboarding() {
    return !store.state.translationLanguage;
  }

  // eslint-disable-next-line class-methods-use-this
  selectTranslationLanguage(code: string) {
    store.commit('setTranslationLanguage', code);
  }
}
</script>
<style lang="scss">
@import "assets/styles/variables.scss";
@import "assets/styles/app.scss";

body {
  margin: 0;
  padding: 0;

  > * {
    max-width: 100vw;
  }
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;

  .view-display {
    margin: 70px 0;
    padding: 0.1px;
  }
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.spinners {
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.header {
  position: fixed;
  width: 100%;
  top: 0;
  background: $light;
  margin: 0;
  padding-top: 15px;
  padding-bottom: 15px;
  display: flex;
  z-index: 1;
  .logo {
    margin: 0 auto;
    max-width: 200px;
  }

  .hamburger {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto 25px;
    font-size: 25px;
  }
}

.language-onboarding {
  &__flags {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin: 15px 0;
  }

  &__flag {
    width: 60px;
    height: 40px;
    object-fit: cover;
    border: 1px solid $dark;
    border-radius: 4px;
    cursor: pointer;
  }
}

.bottom-navigation {
  position: fixed;
  padding: 0;
  bottom: 0;
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  background: $primary;

  .nav-item {
    color: $light;
    text-decoration: none;
    padding: 20px;
    width: 100%;

    &.router-link-exact-active {
      background: $primary-2;
    }
  }
}
</style>
